import * as React from "react";
import { FormattedMessage } from "react-intl";
// components
import ChangeTopInterestDialogContent from "./changeTopInterestDialogContent";
import VingleDialog, { VingleDialogTypes } from "../../../vingleDialog";
import { BasicDialogTypes } from "app/vingleDialog/components/basic";
// styles

const styles = require("./changeTopInterestDialogContent.scss");

interface IChangeTopInterestDialogProps {
  topInterests: ReadonlyArray<Vingle.UserProfile.IProfileInterestState>;
  selectedInterest: Vingle.UserProfile.IProfileInterestState | null;
  currentUser: Vingle.User.ICurrentUser | null;
  isOpen: boolean;
  onRequestClose: (buttonClicked: boolean) => void;
  onRequestSubmit: (
    username: string,
    interest: Vingle.UserProfile.IProfileInterestState,
  ) => Promise<void>;
  onSelectChange: (interest: Vingle.UserProfile.IProfileInterestState) => void;
}

class ChangeTopInterestDialog extends React.PureComponent<
  IChangeTopInterestDialogProps
> {
  public render() {
    const {
      isOpen,
      topInterests,
      selectedInterest,
      onSelectChange,
    } = this.props;

    return (
      <VingleDialog
        type={VingleDialogTypes.BASIC}
        title={
          <FormattedMessage id="profile.change_top_interest_dialog_title" />
        }
        open={isOpen}
        basicContentType={BasicDialogTypes.RADIO}
        omitCancelButton={false}
        submitButtonText={
          <FormattedMessage id="profile.change_top_interest_dialog_submit_button" />
        }
        onRequestClose={this.onRequestClose}
        onRequestSubmit={this.onRequestSubmit}
      >
        <div className={styles.subtitle}>
          <FormattedMessage id="profile.change_top_interest_dialog_subtitle" />
        </div>
        <ChangeTopInterestDialogContent
          topInterests={topInterests}
          selectedInterest={selectedInterest}
          onSelectChange={onSelectChange}
        />
      </VingleDialog>
    );
  }

  private readonly onRequestClose = () => {
    const { onRequestClose } = this.props;
    onRequestClose(true);
  };

  private readonly onRequestSubmit = () => {
    const { onRequestSubmit, currentUser, selectedInterest } = this.props;
    if (selectedInterest && currentUser) {
      onRequestSubmit(currentUser.username, selectedInterest).then(() => {
        this.onRequestClose();
      });
    }
  };
}
export default ChangeTopInterestDialog;
